import upiMethodGooglePay from "assets/images/gpay.png";
import upiMethodPaytm from "assets/images/paytm.png";
import upiMethodPhonePe from "assets/images/phonepe.png";

export enum UpiPaymentApp {
    GOOGLE_PAY = "GOOGLEPAY",
    PHONEPE = "PHONEPE",
    PAYTM = "PAYTM",
}

const UPIAppIconMap: Record<UpiPaymentApp, string> = {
    [UpiPaymentApp.GOOGLE_PAY]: upiMethodGooglePay,
    [UpiPaymentApp.PHONEPE]: upiMethodPhonePe,
    [UpiPaymentApp.PAYTM]: upiMethodPaytm
}